module.exports = {
  localeName: 'ru-RU'
};
